"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lanzo-torinese": {
    "9e5b1005": [{
      "hkey": "81d160ec",
      "slug": "ovairo-brecco",
      "name": "Ovairo-Brecco",
      "primary": true,
      "skipSearch": false
    }],
    "brecco": [{
      "hkey": "81d160ec",
      "slug": "ovairo-brecco",
      "name": "Ovairo-Brecco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lanzo-torinese"
    }],
    "2fe3abee": [{
      "hkey": "064020c5",
      "slug": "lanzo-torinese",
      "name": "Lanzo Torinese",
      "primary": true,
      "skipSearch": false
    }],
    "fua": [{
      "hkey": "064020c5",
      "slug": "lanzo-torinese",
      "name": "Lanzo Torinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "613fa10c": [{
      "hkey": "f336ad8e",
      "slug": "santa-lucia-grange",
      "name": "Santa Lucia-Grange",
      "primary": true,
      "skipSearch": false
    }],
    "grange": [{
      "hkey": "f336ad8e",
      "slug": "santa-lucia-grange",
      "name": "Santa Lucia-Grange",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lanzo-torinese"
    }],
    "81c718ed": [{
      "hkey": "064020c5",
      "slug": "lanzo-torinese",
      "name": "Lanzo Torinese",
      "primary": true,
      "skipSearch": false
    }],
    "monte-basso": [{
      "hkey": "064020c5",
      "slug": "lanzo-torinese",
      "name": "Lanzo Torinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0837f8ee": [{
      "hkey": "81d160ec",
      "slug": "ovairo-brecco",
      "name": "Ovairo-Brecco",
      "primary": true,
      "skipSearch": false
    }],
    "ovairo": [{
      "hkey": "81d160ec",
      "slug": "ovairo-brecco",
      "name": "Ovairo-Brecco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f9c039e9": [{
      "hkey": "f336ad8e",
      "slug": "santa-lucia-grange",
      "name": "Santa Lucia-Grange",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "f336ad8e",
      "slug": "santa-lucia-grange",
      "name": "Santa Lucia-Grange",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;